import requestData, {setFormData,setURLSearchParams,middleErrorInfo,formatterData} from "@/http/request";
const thisFile = 'InvoiceRequest.js.js';
const js = 'InvoiceRequest.js'.toLowerCase();
export function getUserInvoice(ftType = 0) {
    const data = {ftType};
    for (let i in data){
        !data[i] && (delete data[i]);
    }
    return requestData('/invoice/getUserInvoice','POST',data);
}
export function getInvoiceDetail(id=0){
    return requestData('/invoice/getInvoiceDetail','POST',{id});
}
export function addInvoiceData({
    fpType,
    fpCompanyName,
    fpIdCode,
    fpAddress,
    fpPhone,
    fpBankType,
    fpBankCode,
}) {
    return requestData('/invoice/addInvoiceData','POST',{
        fpType,
        fpCompanyName,
        fpIdCode,
        fpAddress,
        fpPhone,
        fpBankType,
        fpBankCode,
    });
}
export function updateInvoiceData({
    fpType,
    fpCompanyName,
    fpIdCode,
    fpAddress,
    fpPhone,
    fpBankType,
    fpBankCode,
    invoiceId,
}){
    return requestData('/invoice/updateInvoiceData','POST',{
        fpType,
        fpCompanyName,
        fpIdCode,
        fpAddress,
        fpPhone,
        fpBankType,
        fpBankCode,
        invoiceId,
    });
}

export function delInvoice(invoiceId=0) {
    if(!invoiceId) return;
    return requestData('/invoice/delInvoice','POST',{invoiceId});
}
export function applyForInvoice(orderId = 0, invoiceId = 0, invoiceAddressId = 0) {
 return requestData('/Invoice/applyForInvoice','POST',{orderId,invoiceId,invoiceAddressId})
}
export function getApplyInvoiceList(page=1,pageSize=20,status=null){
    const data = {page,pageSize};
    status!=null && (data['status']=status);
    return requestData('/applyinvoice/getApplyInvoiceList','POST',data);
}
export function getMorePartList(typeId=0){
    return requestData('/shop/parts/getMorePartList','POST',{typeId});
}